var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "#2980B9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.4395 28.7738L30.5787 24.9038C29.8097 24.1361 28.5362 24.1594 27.7404 24.9573L25.7953 26.9064C25.6724 26.8385 25.5452 26.7676 25.4114 26.6924C24.1831 26.0103 22.5019 25.0753 20.7329 23.3009C18.9585 21.5228 18.0248 19.8352 17.3422 18.6033C17.2701 18.4728 17.2011 18.347 17.1329 18.2275L18.4384 16.921L19.0802 16.277C19.8772 15.4779 19.8992 14.2019 19.132 13.432L15.2711 9.56152C14.5039 8.79271 13.2298 8.81603 12.4328 9.61508L11.3447 10.7119L11.3744 10.7415C11.0096 11.2081 10.7047 11.7463 10.4778 12.3266C10.2686 12.8791 10.1384 13.4062 10.0789 13.9345C9.56909 18.1704 11.5004 22.0417 16.7418 27.2951C23.987 34.5561 29.8256 34.0076 30.0775 33.9808C30.6261 33.9151 31.1518 33.7837 31.6861 33.5758C32.2601 33.351 32.7967 33.0459 33.262 32.681L33.2858 32.7021L34.3881 31.6203C35.1835 30.8214 35.2064 29.5449 34.4395 28.7738Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.5cd684c1.svg";
export { ForwardRef as ReactComponent };